import { apiClient } from "../../Service";
import { collectionToLeaderboardParticipant, objectToLeaderboardLookup, } from "./Transformer";
const LEADERBOARD_LIMIT = 15;
const LEADERBOARD_LOOKUP_LIMIT = 10;
async function getLeaderboard(props) {
    const client = apiClient();
    const params = {
        mission_id: props.missionId,
        filter_period: props.filterPeriod,
        leaderboard_type: props.leaderboardType,
        filter_exercise_types: props.filterExerciseTypes.map((type) => type),
        version: props.version,
        cursor: props.cursor,
        limit: LEADERBOARD_LIMIT,
    };
    return client.get("/appv2/leaderboard/index", { params }).then((response) => {
        return {
            page: collectionToLeaderboardParticipant(response.items),
            version: response.version,
            availableActivities: response.exercise_types,
            distanceUnit: response.distance_unit,
            maxRank: response.max_rank,
            nextCursor: response.next_cursor,
            prevCursor: response.prev_cursor,
            itemsCount: response.count,
        };
    });
}
async function getLeaderboardLookup(props) {
    const client = apiClient();
    const params = {
        id: props.id,
        type: props.type,
        cursor: props.cursor,
        version: props.version,
        limit: LEADERBOARD_LOOKUP_LIMIT,
    };
    return client
        .get("/appv2/leaderboard/lookup", { params })
        .then((response) => {
        return {
            page: objectToLeaderboardLookup(response),
            maxRank: +response.max_rank,
            nextCursor: response.next_cursor,
            prevCursor: response.prev_cursor,
        };
    });
}
export const LeaderboardService = {
    getLeaderboard,
    getLeaderboardLookup,
};
